<template>
  <el-form
    ref="ruleForm"
    :model="inspect"
    :rules="rules"
    label-position="top">
    <el-row :gutter="20">

      <!-- <el-col :span="8">
        <el-form-item label="检测报告名称:"
          prop="inspectReportName">
          <el-input v-model="inspect.inspectReportName"></el-input>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="8">
        <el-form-item label="贸易类型:">
          {{inspect.tradeType | tradeType()}}
        </el-form-item>
      </el-col> -->
      <el-col :span="8">
        <el-form-item
          label="管理/服务机构:"
          prop="regulatorId">
          <vendor-regulator-select
            v-model="inspect.regulatorId"
            :status="isDetail ? 'detail': 'select'"
            :callback="callback"
            :option="{vendorId: inspect.vendorId, tradeType: inspect.tradeType}" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="口岸:"
          prop="seaport">
          <span v-if="isDetail">{{ inspect.seaport }}</span>
          <el-input
            v-else
            v-model="inspect.seaport"></el-input>
        </el-form-item>
      </el-col>
      <!-- <el-col :span="8">
        <el-form-item label="发货日期:"
          prop="shippingTime">
          <el-date-picker v-model="inspect.shippingTime"
            style="width: 100%"
            type="date"
            placeholder="选择发货日期">
          </el-date-picker>
        </el-form-item>
      </el-col> -->
      <el-col :span="8">
        <el-form-item
          label="入关日期:"
          prop="customsClearanceTime">
          <span v-if="isDetail">{{ inspect.customsClearanceTime | dateformat('YYYY-MM-DD') }}</span>
          <el-date-picker
            v-else
            v-model="inspect.customsClearanceTime"
            style="width: 100%"
            type="date"
            placeholder="选择入关日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="经销商:"
          prop="inlandDealer">
          <span v-if="isDetail">{{ inspect.inlandDealer }}</span>
          <el-input
            v-else
            v-model="inspect.inlandDealer"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="经销商地址:"
          prop="inlandDealerAddress">
          <span v-if="isDetail">{{ inspect.inlandDealerAddress }}</span>
          <el-input
            v-else
            v-model="inspect.inlandDealerAddress"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="经销商电话:"
          prop="inlandDealerPhone">
          <span v-if="isDetail">{{ inspect.inlandDealerPhone }}</span>
          <el-input
            v-else
            v-model="inspect.inlandDealerPhone"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="进口商:"
          prop="importer">
          <span v-if="isDetail">{{ inspect.importer }}</span>
          <el-input
            v-else
            v-model="inspect.importer"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="进口商地址:"
          prop="importerAddress">
          <span v-if="isDetail">{{ inspect.importerAddress }}</span>
          <el-input
            v-else
            v-model="inspect.importerAddress"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="进口商电话:"
          prop="importerPhone">
          <span v-if="isDetail">{{ inspect.importerPhone }}</span>
          <el-input
            v-else
            v-model="inspect.importerPhone"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="报关单号:"
          prop="declarationCode">
          <span v-if="isDetail">{{ inspect.declarationCode }}</span>
          <el-input
            v-else
            v-model="inspect.declarationCode"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="报关单:"
          prop="certFile">
          <custom-upload-file
            v-model="inspect.certFile"
            :limit="5"
            mosaic
            rolate
            :status="isDetail ? 'detail' : 'edit'"
            accept="image/*,.pdf" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="检验检疫证书编号:"
          prop="inspectionCode">
          <span v-if="isDetail">{{ inspect.inspectionCode }}</span>
          <el-input
            v-else
            v-model="inspect.inspectionCode"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="检验检疫证书:"
          prop="inspectionFile">
          <custom-upload-file
            v-model="inspect.inspectionFile"
            :limit="5"
            rolate
            :status="isDetail ? 'detail' : 'edit'"
            accept="image/*,.pdf" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
import VendorRegulatorSelect from './vendor-regulator-select.vue'
import clonedeep from 'lodash.clonedeep'
export default {
  name: 'InspectOuterForm',
  components: { CustomUploadFile, VendorRegulatorSelect },
  props: {
    cb: {
      type: Function
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      rules: {
        // inspectReportName: [
        //   { required: true, message: '请输入检测报告名称', trigger: 'blur' },
        //   { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        // ],
        certFile: [
          { type: 'array', required: true, message: '请上传报关单', trigger: 'change' }
        ],
        regulatorId: [
          { required: true, message: '请选择管理/服务机构', trigger: 'blur' }
        ],
        declarationCode: [
          { required: true, message: '请输入报关单号', trigger: 'blur' }
        ],
        inspectionCode: [
          { required: false, message: '请输入报检单号', trigger: 'blur' }
        ],
        seaport: [
          { required: true, message: '请输入口岸', trigger: 'blur' }
        ],
        shippingTime: [
          { required: true, message: '请选择发货日期', trigger: 'blur' }
        ],
        customsClearanceTime: [
          { required: true, message: '请选择入关日期', trigger: 'blur' }
        ],
        inlandDealerPhone: [
          // { pattern: /^1[0-9][0-9]\d{8}$/, required: false, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        importerPhone: [
          // { pattern: /^1[0-9][0-9]\d{8}$/, required: false, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    inspect: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    callback(v) {
      this.cb && this.cb(v)
    },
    submit(cb) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const inspect = clonedeep(this.inspect)
          inspect.certFile = inspect.certFile.map(item => item.url).join(',')
          inspect.inspectionFile = inspect.inspectionFile.map(item => item.url).join(',')
          inspect.shippingTime = inspect.shippingTime ? +inspect.shippingTime : inspect.shippingTime
          inspect.customsClearanceTime = inspect.customsClearanceTime ? +inspect.customsClearanceTime : inspect.customsClearanceTime
          cb && cb(inspect)
        }
      })
    }
  }
}
</script>
